























import Vue from "vue";
import Component from "vue-class-component";
import config from '@/services/api-config';

import './index.scss';

@Component({
  components: { 
  },
  props: {
    nocontrols: Boolean,
    dark: Boolean,
    name: String,
  }
})
export default class WidgetBox extends Vue {
  private visible = true;
  private bodyVisible = true;
  private name: String = this.name;
  private nocontrols: Boolean = this.nocontrols || false;
  private dark: Boolean = this.dark || false;

  mounted() {

  }

  toggleWidget(){
    const widgets = JSON.parse(localStorage[config.widget]);
    for (let widget of widgets){
      if(widget.name == this.name){
        widget.status = false;
        break;
      }
    }

    localStorage[config.widget] = JSON.stringify(widgets);
  }

  closeWindow() {
    this.visible = false;
    this.toggleWidget();
  }

  collapseBody() {
    this.bodyVisible = false;
  }

  openBody() {
    this.bodyVisible = true;
  }
}
